import * as Auth from '@aws-amplify/auth';
import { __LOCAL__ } from '../consts';

/**
 * GQL client to handle queries/mutations
 * @param query gql query/mutation
 * @param variables parameters sent with query/mutation
 */
export const graphQlClient = async (
	query: string,
	variables?: Record<string, any>,
	url: string = process.env.REACT_APP_GRAPHQL!
) => {
	// In Amplify v6, use fetchAuthSession() instead of currentSession()
	const session = await Auth.fetchAuthSession();
	const accessToken = session?.tokens?.idToken?.toString();

	// Check if we have a valid access token
	if (!accessToken && !__LOCAL__) {
		console.error('No valid access token available for GraphQL request');
		throw new Error('User needs to be authenticated to call this API.');
	}

	const localToken = {
		partner_id: 'dev',
		partner_secret: process.env.REACT_APP_GRAPHQL_TOKEN,
	};

	const body = {
		query,
		variables,
	};

	const headers: Record<string, string> = {
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': '*',
	};

	// Add access token if it exists (production)
	if (accessToken) {
		headers.Authorization = `Bearer ${accessToken}`;
	}

	// Add local token for local development
	if (__LOCAL__ && localToken.partner_secret) {
		headers['partner_id'] = localToken.partner_id;
		headers['partner_secret'] = localToken.partner_secret;
	}

	const { data } = await fetch(url, {
		method: 'POST',
		headers,
		body: JSON.stringify(body),
	}).then((res) => res.json());

	return data ? data?.[Object.keys(data)[0]] : null;
};
